var map = {
	"./pr-1.png": "2534",
	"./pr-10.png": "94f2",
	"./pr-11.png": "2d47",
	"./pr-12.png": "3f15",
	"./pr-13.png": "82da",
	"./pr-2.png": "2501",
	"./pr-3.png": "179f",
	"./pr-4.png": "1c1b",
	"./pr-5.png": "4413",
	"./pr-6.png": "eac8",
	"./pr-7.png": "5550",
	"./pr-8.png": "ec5d",
	"./pr-9.png": "140b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "94c9";